export default "__VITE_ASSET__4622624d__"